import request from "../utils/request"; // 获取待审核列表

export var categorylist = function categorylist(data) {
  return request({
    url: '/book/info',
    method: 'post',
    data: data
  });
}; // 审核

export var auditex = function auditex(data) {
  return request({
    url: '/audit/book',
    method: 'post',
    data: data
  });
}; // 删除

export var deleteAudit = function deleteAudit(data) {
  return request({
    url: '/book/remove',
    method: 'post',
    data: data
  });
};